import React from "react";
import Carousel from "react-bootstrap/Carousel";
import FirstWallpaper from "../assets/images/wall1.jpg";
import SecondWallpaper from "../assets/images/wall2.png";

const CarouselBanner = () => {
  return (
    <div className="container-fluid g-0">
      <Carousel dir="ltr" fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={SecondWallpaper}
            alt="پایش کیفیت هوا"
          />
          <Carousel.Caption className="text-center">
            <h1
              className="display-4 IRANSansXG my-3 mx-2"
              style={{ color: "#212529" }}
            >
              <strong>پایش هوای محیطی</strong>
            </h1>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <Carousel.Caption>
            <h1
              className="display-4 IRANSansXG my-3"
              style={{ color: "#f6f3e1" }}
            >
              <strong>پایش دودکش های صنعتی</strong>
            </h1>
          </Carousel.Caption>
          <img
            className="d-block w-100"
            src={FirstWallpaper}
            alt="پایش دودکش های صنعتی"
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default CarouselBanner;
